import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { RootState } from 'src/features';
import { actions } from 'src/features/resort';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { ResortFollowRouting } from '../common/ResortFollowRouting';
import { ResortReportRouting } from '../promotion/report/ResortReportRouting';
import { resortDeepLinkContentSelector } from '../selectors/resortDeepLinkContentSelector';
import { ResortDeepLinkContainer } from './ResortDeepLinkContainer';
import { ResortDeepLinkLocked } from './ResortDeepLinkLocked';
import { ResortDeepLinkUnlocked } from './ResortDeepLinkUnlocked';

export const ResortDeepLinkPromotion: React.FC = () => {
  const { raid } = useParams<{ raid?: string }>();
  const { unlockFlags, country } = useSelector((state: RootState) => state.user);
  const resortUserInfo = useSelector(resortDeepLinkContentSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      raid &&
      // 既に対象ユーザーの情報を取得済みであれば、API通信を行わない
      (resortUserInfo?.state !== 'ok' || raid !== resortUserInfo.result.profile.resortPlannerId)
    ) {
      dispatch(actions.getDeepLinkInfo(raid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, raid]);

  if (!unlockFlags || !country) {
    return null;
  }

  const { hasAoc, isUnlockedResortAppNet } = unlockFlags;
  const isLocked = !hasAoc || !isUnlockedResortAppNet; // OneRoom未所持、 ツクッターの宣伝機能未解禁

  return (
    <>
      {(() => {
        switch (resortUserInfo?.state) {
          case 'ok': {
            const { profile } = resortUserInfo.result;
            const userColor = getResortUserColor(profile.resortPlannerPromotionColor);
            const decoId = profile.resortPlannerPromotionDeco;
            if (isLocked) {
              return (
                <ResortDeepLinkContainer isDefaultHeader={true}>
                  <ResortDeepLinkLocked
                    {...resortUserInfo.result}
                    hasAoc={hasAoc}
                    country={country}
                  />
                </ResortDeepLinkContainer>
              );
            } else {
              return (
                <ResortDeepLinkContainer
                  isDefaultHeader={false}
                  userColor={userColor}
                  decoId={decoId}
                >
                  <ResortDeepLinkUnlocked {...resortUserInfo.result} />
                </ResortDeepLinkContainer>
              );
            }
          }
          case 'pending':
            return (
              <ResortDeepLinkContainer isDefaultHeader={false}>
                <Loading color="#aea681" />
              </ResortDeepLinkContainer>
            );
          case 'error':
            return (
              <ResortDeepLinkContainer isDefaultHeader={true}>
                <LoadingFailed error={resortUserInfo.error} />
              </ResortDeepLinkContainer>
            );
          default:
            return null;
        }
      })()}

      <ResortReportRouting />
      <ResortFollowRouting />
    </>
  );
};
